

















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import BundleDiscountPillWithTitle from '@/components/molecules/discount/BundleDiscountPillWithTitle.vue'
import { BundleDiscount } from '@/services/api/bundle-discount'

import { ApparelAddToCartSelectionState } from './selection-state'

@Component({
  components: {
    BundleDiscountPillWithTitle,
  },
})
export default class BundleDiscountSection extends Vue {
  @Prop({ required: true })
  state: ApparelAddToCartSelectionState

  get bundleDiscount(): BundleDiscount | null {
    return this.state.selectedFku.map(fku => fku.bundleDiscount).toNullable()
  }
}
